import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const canModifyRequest = async (requestId: string, userId: string): Promise<boolean> => {
  try {
    if (!userId || userId === '') {
      console.log('Pas d\'userId fourni ou userId vide');
      return false;
    }
    
    const requestRef = doc(db, '2dr_requests', requestId);
    const requestDoc = await getDoc(requestRef);
    
    if (!requestDoc.exists()) {
      console.log('Document non trouvé:', requestId);
      return false;
    }
    
    const request = requestDoc.data();
    console.log('Données de la demande:', {
      requestId,
      userId: request.userId,
      currentUserId: userId,
      donations: request.donations
    });
    
    // Vérifier si l'utilisateur est le propriétaire
    const isOwner = request.userId === userId;
    console.log('Est propriétaire ?', isOwner);
    
    // Vérifier si la demande a des donations
    const donations = request.donations || [];
    const hasDonations = Array.isArray(donations) && donations.length > 0;
    console.log('A des donations ?', hasDonations);
    
    const canModify = isOwner && !hasDonations;
    console.log('Peut modifier ?', canModify);
    
    return canModify;
  } catch (error) {
    console.error('Erreur lors de la vérification des droits:', error);
    return false;
  }
};

export const isRequestOwner = (requestData: any, currentUser: any): boolean => {
  if (!requestData || !currentUser) return false;
  
  return (
    currentUser.id === requestData.userId || 
    currentUser.uid === requestData.userId
  );
}; 